<template>
  <div :style="divStyle">
    <v-row no-gutters>
      <v-col mols="12" class="d-flex align-center justify-space-between">
        <span class="editor-title">{{ subTitle ? subTitle : '' }}</span>
        <v-switch v-model="expandToggle" color="primary">
          <template v-slot:label>
            <span class="ml-2 main_text--text switch-label"> {{ expandToggleText }} </span>
          </template>
        </v-switch>
      </v-col>
      <!-- 패널 -->
      <v-col cols="12" class="mt-4">
        <v-card v-if="localDataSource.length > 0">
          <v-expansion-panels v-model="expandedPanel" multiple flat>
            <v-expansion-panel v-for="(row, i) in localDataSource" :key="i">
              <v-expansion-panel-header v-bind:color="titleColorList[i] ? titleColorList[i].color : ''" @click="titleClick(i)">
                <div class="d-flex justify-space-between">
                  <!-- Main Titile -->
                  <span :style="mainStyle"
                    >{{ row.main }}
                    <v-divider vertical class="mx-3" />
                    <!-- Sub Titile 1 -->
                    <span :style="sub1Style">{{ row.sub1 }}</span></span
                  >
                  <!-- Sub Titile 2 -->
                  <span :style="sub2Style">{{ row.sub2 }}</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <!-- Text -->
                <div class="d-flex">
                  <v-textarea
                    v-model="row.text"
                    rows="1"
                    row-height="5"
                    solo
                    no-resize
                    auto-grow
                    spellcheck="false"
                    hide-details="auto"
                    :class="row.readonly ? 'readonly' : 'editor_bg'"
                    :readonly="row.readonly"
                  />
                  <template v-if="!readonly">
                    <template v-if="row.userCd !== userCd">
                      <v-tooltip top max-width="520px">
                        <template v-slot:activator="{ on }">
                          <button style="cursor: not-allowed">
                            <v-icon medium v-on="on"> {{ 'mdi-pencil-off' }}</v-icon>
                          </button>
                        </template>
                        <span>{{ '작성자만 수정할 수 있습니다.' }}</span>
                      </v-tooltip>
                      <v-tooltip top max-width="520px">
                        <template v-slot:activator="{ on }">
                          <button style="cursor: not-allowed">
                            <v-icon medium v-on="on"> {{ 'mdi-delete-off' }}</v-icon>
                          </button>
                        </template>
                        <span>{{ '작성자만 삭제할 수 있습니다.' }}</span>
                      </v-tooltip>
                    </template>
                    <template v-else>
                      <v-tooltip top max-width="520px">
                        <template v-slot:activator="{ on }">
                          <button @click="changeEditMode(i)">
                            <v-icon medium v-on="on"> {{ row.readonly ? 'mdi-pencil' : 'mdi-content-save-edit' }}</v-icon>
                          </button>
                        </template>
                        <template v-if="row.readonly">
                          <span>
                            <v-icon small> {{ 'mdi-pencil' }}</v-icon>
                            {{ '아이콘을 클릭하여 작성된 내용을 편집하세요.' }}
                          </span>
                          <br />
                          <span>
                            {{ '수정 완료 후에' }}
                            <v-icon small> {{ 'mdi-content-save-edit' }}</v-icon>
                            {{ '아이콘을 클릭하여 수정된 내용을 저장하세요.' }}
                          </span>
                        </template>
                        <template v-else>
                          <span>
                            <v-icon small> {{ 'mdi-content-save-edit' }}</v-icon>
                            {{ '아이콘을 클릭하여 수정된 내용을 저장하세요.' }}
                          </span>
                        </template>
                      </v-tooltip>
                      <v-tooltip top max-width="520px">
                        <template v-slot:activator="{ on }">
                          <button @click="deleteData(i)">
                            <v-icon medium v-on="on"> {{ 'mdi-delete' }}</v-icon>
                          </button>
                        </template>
                        <span>{{ '근로자 의견을 삭제합니다.' }}</span>
                      </v-tooltip>
                    </template>
                  </template>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
        <v-card v-else height="100%">
          <p class="grey--text d-flex justify-center align-center">근로자 의견이 없습니다.</p>
        </v-card>
        <v-card>
          <div v-if="!readonly" class="d-flex mt-4">
            <v-textarea v-model="newDataText" :placeholder="newDataPlaceholder" no-resize solo class="editor_bg"></v-textarea>
            <v-tooltip top max-width="520px">
              <template v-slot:activator="{ on }">
                <button @click="saveNewData">
                  <v-icon medium v-on="on"> {{ 'mdi-content-save-edit' }}</v-icon>
                </button>
              </template>
              <template>
                <v-icon small> {{ 'mdi-content-save-edit' }}</v-icon>
                <span>
                  {{ '아이콘을 클릭하여 수정된 내용을 저장하세요.' }}
                </span>
              </template>
            </v-tooltip>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getUserCd } from '@/utils/token'
export default {
  components: {},
  name: 'expansionPanelList',
  props: {
    subTitle: {
      type: String,
      default: '',
    },
    datasource: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: true,
    },
    maxCnt: {
      type: Number,
      default: 0,
    },
    headerDefaultColor: {
      type: String,
      default: '#fff',
    },
    headerExpandedColor: {
      type: String,
      default: '#fff',
    },
    mainStyle: {
      type: String,
      default: 'font-size: 1rem; font-weight: 600',
    },
    sub1Style: {
      type: String,
      default: 'font-size: 1rem; font-weight: 400;',
    },
    sub2Style: {
      type: String,
      default: 'font-size: 1rem; font-weight: 400',
    },
    textStyle: {
      type: String,
      default: 'font-size: medium;',
    },
    divStyle: {
      type: String,
      default: '',
    },
    firstDataExpand: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expandedPanel: [],
      titleColorList: [],
      expandToggleText: '전부 펼치기',
      expandToggle: false,
      localDataSource: [],
      userCd: getUserCd(),
      newDataText: '',
      newDataPlaceholder: '근로자 의견을 입력하세요.',
      isNotify: false,
      editMode: false,
    }
  },
  watch: {
    datasource() {
      this.titleColorList = []
      this.datasource.forEach((row) => {
        let defaultColor = {
          color: this.headerDefaultColor,
        }
        this.titleColorList.push(defaultColor)
        row.readonly = true
      })
      this.localDataSource = _.cloneDeep(this.datasource)
      this.expandedPanel = []
    },
    expandToggle() {
      if (this.expandToggle == false) {
        this.collapseAllPanel()
        this.expandToggleText = '전부 펼치기'
      } else {
        this.expandAllPanel()
        this.expandToggleText = '전부 접기'
      }
    },
  },
  computed: {},
  mounted() {
    if (this.maxCnt > 0) {
      this.newDataPlaceholder =
        ' 최대 ' + this.maxCnt + '개까지 입력할 수 있습니다. 최대 개수를 초과할 경우 자동으로 가장 최신의 기존 근로자 의견을 업데이트 합니다.'
    }
    this.datasource.forEach((row, i) => {
      let defaultColor = {
        color: i == 0 && this.firstDataExpand ? this.headerExpandedColor : this.headerDefaultColor,
      }
      this.titleColorList.push(defaultColor)
      row.readonly = true
    })
    this.localDataSource = _.cloneDeep(this.datasource)

    if (this.firstDataExpand) {
      this.expandedPanel = [0]
    }
  },
  methods: {
    initTitleColorList() {
      this.localDataSource.forEach((row, i) => {
        this.titleColorList[i].color = this.headerDefaultColor
      })
    },
    titleClick(index) {
      if (this.titleColorList[index].color === this.headerDefaultColor) {
        this.titleColorList[index].color = this.headerExpandedColor
      } else {
        this.titleColorList[index].color = this.headerDefaultColor
      }
    },
    collapseAllPanel() {
      this.initTitleColorList()
      this.expandedPanel = []
    },
    expandAllPanel() {
      this.expandedPanel = []
      this.localDataSource.forEach((row, i) => {
        this.titleColorList[i].color = this.headerExpandedColor
        this.expandedPanel.push(i)
      })
    },
    saveNewData() {
      this.$emit('save', this.newDataText)
      this.newDataText = ''
    },
    changeEditMode(index) {
      this.localDataSource[index].readonly = !this.localDataSource[index].readonly
      if (this.localDataSource[index].readonly) {
        this.$emit('update', this.localDataSource[index])
      }
    },
    deleteData(index) {
      this.$emit('delete', this.localDataSource[index])
    },
  },
}
</script>
